import { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

interface ScrollRevealBeforeAfterProps {
  beforeImage: string;
  afterImage: string;
}

/**
 * Scroll-based Before/After Image Reveal
 *
 * Kullanıcı scroll yaptıkça "before" görsel fade out olur, "after" görsel fade in olur.
 * Şeffaf arka planlı görseller beyaz zemin üzerinde görünür - kare içinde değil.
 * Label yok - sadece görsel geçişi.
 */
export const ScrollRevealBeforeAfter = ({
  beforeImage,
  afterImage,
}: ScrollRevealBeforeAfterProps) => {
  const containerRef = useRef<HTMLDivElement>(null);

  // Section viewport'a girdiğinde ve çıktığında scroll progress
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ['start 0.8', 'end 0.2'],
  });

  // Before image: başta görünür, scroll ile kaybolur
  const beforeOpacity = useTransform(scrollYProgress, [0, 0.35, 0.5], [1, 1, 0]);

  // After image: başta gizli, scroll ile ortaya çıkar
  const afterOpacity = useTransform(scrollYProgress, [0.35, 0.5, 1], [0, 1, 1]);

  return (
    <section
      ref={containerRef}
      className="relative w-full bg-white py-12 md:py-20"
    >
      <div className="container mx-auto px-2 md:px-4 lg:px-8">
        {/* Image Container - larger size */}
        <div className="relative max-w-6xl mx-auto flex items-center justify-center" style={{ minHeight: '45vh' }}>
          {/* Before Image */}
          <motion.div
            className="relative w-full flex items-center justify-center"
            style={{ opacity: beforeOpacity }}
          >
            <img
              src={beforeImage}
              alt="Üretim aşaması"
              className="w-full h-auto max-h-[65vh] md:max-h-[80vh] object-contain"
              draggable={false}
            />
          </motion.div>

          {/* After Image - Absolute overlay */}
          <motion.div
            className="absolute inset-0 w-full h-full flex items-center justify-center"
            style={{ opacity: afterOpacity }}
          >
            <img
              src={afterImage}
              alt="Tamamlanmış ürün"
              className="w-full h-auto max-h-[65vh] md:max-h-[80vh] object-contain"
              draggable={false}
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};
